import Wix from '../services/wix-sdk-polyfill';
import getUserPrivacyStatus from '../services/get-user-privacy-status';
import { updateUserPrivacyStatus } from '../actions/update-user-privacy-status';
import { VIEW_MODE_SITE } from '../constants/view-modes';
import { EXPERIMENT_MEMBERS_AREA } from '../constants/experiments';
import { getViewMode } from '../services/wix-sdk-utils';
import { isExperimentEnabled } from '../selectors/experiments-selectors';

const listenToMemberDetailsUpdated = store => {
  const updatePrivacyStatus = () => {
    if (getViewMode() === VIEW_MODE_SITE) {
      getUserPrivacyStatus(privacyStatus => {
        store.dispatch(updateUserPrivacyStatus(privacyStatus));
      });
    }
  };

  if (isExperimentEnabled(store.getState(), EXPERIMENT_MEMBERS_AREA)) {
    Wix.addEventListener(Wix.Events.MEMBER_DETAILS_UPDATED, updatePrivacyStatus);
    updatePrivacyStatus();
  }
};

export default listenToMemberDetailsUpdated;



// WEBPACK FOOTER //
// ./app/services/listen-to-member-details-updated.js